import React from 'react';
import { useRouteError } from 'react-router-dom';
import { dlDispatchAmplEvent } from '../../events/dl.dispatchAmplEvent';
export const ErrorElement = () => {
    const error = useRouteError();
    dlDispatchAmplEvent('error', {
        details: 'Oops',
        error
    });
    return (React.createElement("div", { className: "text:center page-width py:32 py:56:md-up" },
        React.createElement("h1", { className: "fz:28 fz:40:lg-up" }, "Oops!.."),
        React.createElement("p", { className: "fz:20 fz:28:lg-up" }, "Something went wrong")));
};
